/*
 * Copyright (c) 2023 Bluemate B.V.
 */

import './style/primereact-theme/themes/mytheme/theme.scss';
import 'primereact/resources/primereact.css';
import './style/custom.scss';
import './style/custom-fonts.scss';
import './style/normalize.css';

import 'react-app-polyfill/stable';
import './js/util/startup';
import React from 'react';
import {createRoot} from 'react-dom/client';
import {AppContextProvider} from './js/components/misc/appContext';
import AdminContextProvider from './js/components/misc/adminContext';
import {LayoutProvider} from './js/components/misc/layoutContext';
import {Routes} from './js/routes';
import {createBrowserRouter, RouterProvider} from 'react-router';

const router = createBrowserRouter(Routes);

const rootElement = document.getElementById('content');
if (rootElement) {
    createRoot(rootElement).render(
        <AppContextProvider>
            <LayoutProvider>
                <AdminContextProvider>
                    <RouterProvider router={router} />
                </AdminContextProvider>
            </LayoutProvider>
        </AppContextProvider>
    );
}
